import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { logger, unionBy } from '@ninetailed/experience.js-shared';
import { OnChangeEmitter, PROFILE_CHANGE, isExperienceMatch, selectDistribution } from '@ninetailed/experience.js';
import { NinetailedPlugin } from '@ninetailed/experience.js-plugin-analytics';
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var CONTAINER_WIDTH = 432;
var BUTTON_WIDTH = 48;
var BUTTON_HEIGHT = 192;
var BUTTON_BOTTOM_POSITION = 128;
var TRANSFORM_CLOSED = "translate(".concat(CONTAINER_WIDTH - BUTTON_WIDTH, "px, 0px)");
var TRANSFORM_CLOSED_HIDE = "translate(".concat(CONTAINER_WIDTH, "px, 0px)");
var TRANSFORM_OPEN = "translate(0px, 0px)";
var WidgetContainer = /*#__PURE__*/function () {
  function WidgetContainer(options) {
    _classCallCheck(this, WidgetContainer);
    var _options$ui;
    this.container = void 0;
    this.options = options;
    this.container = document.createElement('div');
    this.container.style.position = 'fixed';
    this.container.style.zIndex = '999999';
    this.container.style.right = '0px';
    this.container.style.bottom = "".concat(BUTTON_BOTTOM_POSITION, "px");
    this.container.style.width = "".concat(CONTAINER_WIDTH, "px");
    this.container.style.height = "".concat(BUTTON_HEIGHT, "px");
    if ((_options$ui = options.ui) != null && (_options$ui = _options$ui.opener) != null && _options$ui.hide) {
      this.container.style.transform = TRANSFORM_CLOSED_HIDE;
    } else {
      this.container.style.transform = TRANSFORM_CLOSED;
    }
    this.container.style.transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
    this.container.style.transitionDuration = '700ms';
    this.container.style.transitionProperty = 'transform';
    document.body.appendChild(this.container);
  }
  return _createClass(WidgetContainer, [{
    key: "open",
    value: function open() {
      this.container.style.transform = TRANSFORM_OPEN;
      this.container.style.height = '100vh';
      this.container.style.bottom = "0px";
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;
      var _this$options$ui;
      if ((_this$options$ui = this.options.ui) != null && (_this$options$ui = _this$options$ui.opener) != null && _this$options$ui.hide) {
        this.container.style.transform = TRANSFORM_CLOSED_HIDE;
      } else {
        this.container.style.transform = TRANSFORM_CLOSED;
      }
      setTimeout(function () {
        _this2.container.style.height = "".concat(BUTTON_HEIGHT, "px");
        _this2.container.style.bottom = "".concat(BUTTON_BOTTOM_POSITION, "px");
      }, 700);
    }
  }, {
    key: "element",
    get: function get() {
      return this.container;
    }
  }]);
}();
var NinetailedPreviewPlugin = /*#__PURE__*/function (_NinetailedPlugin) {
  function NinetailedPreviewPlugin(options) {
    var _this3;
    _classCallCheck(this, NinetailedPreviewPlugin);
    var _this;
    _this3 = _callSuper(this, NinetailedPreviewPlugin);
    _this = _this3;
    _this3.name = 'ninetailed:preview' + Math.random();
    _this3.isOpen = false;
    _this3.experiences = [];
    _this3.audienceDefinitions = [];
    _this3.audienceOverwrites = {};
    _this3.experienceVariantIndexOverwrites = {};
    _this3.profile = null;
    _this3.container = null;
    _this3.bridge = null;
    _this3.onChangeEmitter = new OnChangeEmitter();
    _this3.onOpenExperienceEditor = void 0;
    _this3.onOpenAudienceEditor = void 0;
    _this3.clientId = null;
    _this3.environment = null;
    _this3.initialize = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _window$ninetailed, _yield$import, PreviewBridge;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window !== 'undefined')) {
              _context.next = 10;
              break;
            }
            _context.next = 3;
            return import('@ninetailed/experience.js-preview-bridge');
          case 3:
            _yield$import = _context.sent;
            PreviewBridge = _yield$import.PreviewBridge;
            _this.container = new WidgetContainer({
              ui: _this.options.ui
            });
            _this.bridge = PreviewBridge({
              url: _this.options.url
            });
            _this.bridge.render(_this.container.element);
            window.ninetailed = Object.assign({}, window.ninetailed, {
              plugins: Object.assign({}, (_window$ninetailed = window.ninetailed) == null ? void 0 : _window$ninetailed.plugins, {
                preview: _this.windowApi
              })
            });
            _this.bridge.updateProps({
              props: _this.pluginApi
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    _this3.loaded = function () {
      return true;
    };
    _this3[PROFILE_CHANGE] = function (_ref2) {
      var payload = _ref2.payload;
      if (payload != null && payload.profile) {
        _this3.onProfileChange(payload.profile);
      }
    };
    _this3.getExperienceSelectionMiddleware = function (_ref3) {
      var baseline = _ref3.baseline,
        experiences = _ref3.experiences;
      return function () {
        var experienceIds = Object.keys(_this3.pluginApi.experienceVariantIndexes);
        var experience = experiences.find(function (experience) {
          return experienceIds.includes(experience.id);
        });
        if (!experience) {
          return {
            experience: null,
            variant: baseline,
            variantIndex: 0
          };
        }
        var baselineComponent = experience.components.find(function (component) {
          return component.baseline.id === baseline.id;
        });
        if (!baselineComponent) {
          return {
            experience: experience,
            variant: baseline,
            variantIndex: 0
          };
        }
        var allVariants = [baseline].concat(_toConsumableArray(baselineComponent.variants));
        var variantIndex = _this3.pluginApi.experienceVariantIndexes[experience.id];
        if (allVariants.length <= variantIndex) {
          return {
            experience: experience,
            variant: baseline,
            variantIndex: 0
          };
        }
        var variant = allVariants[variantIndex];
        if (!variant) {
          return {
            experience: experience,
            variant: baseline,
            variantIndex: 0
          };
        }
        return {
          experience: experience,
          variant: variant,
          variantIndex: variantIndex
        };
      };
    };
    _this3.onChange = function () {
      var _window$ninetailed2;
      logger.debug('Ninetailed Preview Plugin onChange pluginApi:', _this3.pluginApi);
      Object.assign({}, window.ninetailed, {
        plugins: Object.assign({}, (_window$ninetailed2 = window.ninetailed) == null ? void 0 : _window$ninetailed2.plugins, {
          preview: _this3.windowApi
        })
      });
      _this3.bridge.updateProps({
        props: _this3.pluginApi
      });
      _this3.onChangeEmitter.invokeListeners();
    };
    _this3.onProfileChange = function (profile) {
      _this3.profile = profile;
      _this3.onChange();
    };
    _this3.setCredentials = function (_ref4) {
      var clientId = _ref4.clientId,
        environment = _ref4.environment;
      _this3.clientId = clientId;
      _this3.environment = environment;
    };
    _this3.options = options;
    _this3.experiences = options.experiences || [];
    _this3.audienceDefinitions = options.audiences || [];
    _this3.onOpenExperienceEditor = options.onOpenExperienceEditor;
    _this3.onOpenAudienceEditor = options.onOpenAudienceEditor;
    return _this3;
  }
  _inherits(NinetailedPreviewPlugin, _NinetailedPlugin);
  return _createClass(NinetailedPreviewPlugin, [{
    key: "open",
    value: function open() {
      var _this$container;
      (_this$container = this.container) == null || _this$container.open();
      this.isOpen = true;
      this.onChange();
    }
  }, {
    key: "close",
    value: function close() {
      var _this4 = this;
      var _this$container2;
      (_this$container2 = this.container) == null || _this$container2.close();
      setTimeout(function () {
        _this4.isOpen = false;
        _this4.onChange();
      }, 700);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: "activateAudience",
    value: function activateAudience(id) {
      var _this5 = this;
      if (!this.isKnownAudience(id)) {
        logger.warn("You cannot activate an unknown audience (id: ".concat(id, ")."));
        return;
      }
      this.audienceOverwrites = Object.assign({}, this.audienceOverwrites, _defineProperty({}, id, true));
      this.experienceVariantIndexOverwrites = Object.assign({}, this.experienceVariantIndexOverwrites, this.experiences.filter(function (experience) {
        var _experience$audience;
        return ((_experience$audience = experience.audience) == null ? void 0 : _experience$audience.id) === id;
      }).map(function (experience) {
        return experience.id;
      }).reduce(function (acc, curr) {
        return Object.assign({}, acc, _defineProperty({}, curr, _this5.experienceVariantIndexes[curr] || 0));
      }, {}));
      this.onChange();
    }
  }, {
    key: "deactivateAudience",
    value: function deactivateAudience(id) {
      var _this6 = this;
      if (!this.isKnownAudience(id)) {
        logger.warn("You cannot deactivate an unkown audience (id: ".concat(id, "). How did you get it in the first place?"));
        return;
      }
      this.experienceVariantIndexOverwrites = Object.entries(this.experienceVariantIndexOverwrites).filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          _ = _ref6[1];
        return !_this6.experiences.filter(function (experience) {
          var _experience$audience2;
          return ((_experience$audience2 = experience.audience) == null ? void 0 : _experience$audience2.id) === id;
        }).map(function (experience) {
          return experience.id;
        }).includes(key);
      }).reduce(function (acc, _ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];
        return Object.assign({}, acc, _defineProperty({}, key, value));
      }, {});
      this.audienceOverwrites = Object.assign({}, this.audienceOverwrites, _defineProperty({}, id, false));
      this.onChange();
      this.experiences.filter(function (experience) {
        var _experience$audience3;
        return ((_experience$audience3 = experience.audience) == null ? void 0 : _experience$audience3.id) === id;
      }).forEach(function (experience) {
        _this6.setExperienceVariant({
          experienceId: experience.id,
          variantIndex: 0
        });
      });
      this.audienceOverwrites = Object.assign({}, this.audienceOverwrites, _defineProperty({}, id, false));
      this.onChange();
    }
  }, {
    key: "resetAudience",
    value: function resetAudience(id) {
      if (!this.isKnownAudience(id)) {
        logger.warn("You cannot reset an unknown audience (id: ".concat(id, "). How did you get it in the first place?"));
        return;
      }
      var _this$audienceOverwri = this.audienceOverwrites,
        audienceOverwrites = _objectWithoutPropertiesLoose(_this$audienceOverwri, [id].map(_toPropertyKey));
      this.audienceOverwrites = audienceOverwrites;
      this.onChange();
    }
  }, {
    key: "setExperienceVariant",
    value: function setExperienceVariant(_ref9) {
      var experienceId = _ref9.experienceId,
        variantIndex = _ref9.variantIndex;
      var experience = this.experiences.find(function (experience) {
        return experience.id === experienceId;
      });
      if (!experience) {
        logger.warn("You cannot active a variant for an unknown experience (id: ".concat(experienceId, ")"));
        return;
      }
      if (experience.audience && !this.activeAudiences.some(function (id) {
        var _experience$audience4;
        return id === ((_experience$audience4 = experience.audience) == null ? void 0 : _experience$audience4.id);
      })) {
        logger.warn("You cannot active a variant for an experience (id: ".concat(experienceId, "), which is not in the active audiences."));
        return;
      }
      var isValidIndex = experience.components.map(function (component) {
        return component.variants.length + 1;
      }).every(function (length) {
        return length > variantIndex;
      });
      if (!isValidIndex) {
        logger.warn("You activated a variant at index ".concat(variantIndex, " for the experience (id: ").concat(experienceId, "). Not all components have that many variants, you may see the baseline for some."));
      }
      this.experienceVariantIndexOverwrites = Object.assign({}, this.experienceVariantIndexOverwrites, _defineProperty({}, experienceId, variantIndex));
      this.onChange();
    }
  }, {
    key: "resetExperience",
    value: function resetExperience(experienceId) {
      var _this$experienceVaria = this.experienceVariantIndexOverwrites,
        experienceVariantIndexOverwrites = _objectWithoutPropertiesLoose(_this$experienceVaria, [experienceId].map(_toPropertyKey));
      this.experienceVariantIndexOverwrites = experienceVariantIndexOverwrites;
      this.onChange();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (typeof window !== 'undefined' && window.ninetailed && typeof window.ninetailed.reset === 'function') {
        window.ninetailed.reset();
      }
    }
  }, {
    key: "openExperienceEditor",
    value: function openExperienceEditor(experience) {
      if (this.onOpenExperienceEditor && typeof this.onOpenExperienceEditor === 'function') return this.onOpenExperienceEditor(experience);
    }
  }, {
    key: "openExperienceAnalytics",
    value: function openExperienceAnalytics(experience) {
      window.open("https://app.ninetailed.io/".concat(this.clientId, "/").concat(this.environment, "/experiences/").concat(experience.id), '_blank');
    }
  }, {
    key: "openAudienceEditor",
    value: function openAudienceEditor(audience) {
      if (this.onOpenAudienceEditor && typeof this.onOpenAudienceEditor === 'function') return this.onOpenAudienceEditor(audience);
    }
  }, {
    key: "pluginApi",
    get: function get() {
      var _this$profile;
      return {
        version: "7.7.3",
        open: this.open.bind(this),
        close: this.close.bind(this),
        toggle: this.toggle.bind(this),
        isOpen: this.isOpen,
        activateAudience: this.activateAudience.bind(this),
        deactivateAudience: this.deactivateAudience.bind(this),
        resetAudience: this.resetAudience.bind(this),
        apiAudiences: ((_this$profile = this.profile) == null ? void 0 : _this$profile.audiences) || [],
        audienceOverwrites: this.audienceOverwrites,
        activeAudiences: this.activeAudiences,
        audienceDefinitions: this.audienceDefinitions,
        setExperienceVariant: this.setExperienceVariant.bind(this),
        resetExperience: this.resetExperience.bind(this),
        apiExperienceVariantIndexes: this.apiExperienceVariantIndexes,
        experienceVariantIndexes: Object.assign({}, this.experienceVariantIndexes, this.experienceVariantIndexOverwrites),
        experienceVariantIndexOverwrites: this.experienceVariantIndexOverwrites,
        reset: this.reset.bind(this),
        experiences: this.experiences,
        openExperienceEditor: this.onOpenExperienceEditor ? this.openExperienceEditor.bind(this) : undefined,
        openExperienceAnalytics: this.openExperienceAnalytics.bind(this),
        openAudienceEditor: this.onOpenAudienceEditor ? this.openAudienceEditor.bind(this) : undefined
      };
    }
  }, {
    key: "windowApi",
    get: function get() {
      return {
        version: '2.0.0',
        open: this.open.bind(this),
        close: this.close.bind(this),
        toggle: this.toggle.bind(this),
        activateAudience: this.activateAudience.bind(this),
        deactivateAudience: this.deactivateAudience.bind(this),
        resetAudience: this.resetAudience.bind(this),
        activeAudiences: this.activeAudiences,
        setExperienceVariant: this.setExperienceVariant.bind(this),
        resetExperience: this.resetExperience.bind(this),
        experienceVariantIndexes: Object.assign({}, this.experienceVariantIndexes, this.experienceVariantIndexOverwrites)
      };
    }
  }, {
    key: "isKnownAudience",
    value: function isKnownAudience(id) {
      return this.potentialAudiences.some(function (audience) {
        return audience.id === id;
      });
    }
  }, {
    key: "potentialAudiences",
    get: function get() {
      var audiencesFromExperiences = this.experiences.map(function (experience) {
        return experience.audience;
      }).filter(function (audience) {
        return !!audience;
      });
      return unionBy(this.audienceDefinitions, audiencesFromExperiences, 'id');
    }
  }, {
    key: "activeAudiences",
    get: function get() {
      var _this$profile2;
      var deactivatedAudiences = Object.entries(this.audienceOverwrites).filter(function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 2),
          id = _ref11[0],
          active = _ref11[1];
        return !active;
      }).map(function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 1),
          id = _ref13[0];
        return id;
      });
      var activatedAudiences = Object.entries(this.audienceOverwrites).filter(function (_ref14) {
        var _ref15 = _slicedToArray(_ref14, 2),
          id = _ref15[0],
          active = _ref15[1];
        return active;
      }).map(function (_ref16) {
        var _ref17 = _slicedToArray(_ref16, 1),
          id = _ref17[0];
        return id;
      });
      return [].concat(_toConsumableArray(((_this$profile2 = this.profile) == null ? void 0 : _this$profile2.audiences) || []), _toConsumableArray(activatedAudiences)).filter(function (id) {
        return !deactivatedAudiences.includes(id);
      });
    }
  }, {
    key: "calculateExperienceVariantIndexes",
    value: function calculateExperienceVariantIndexes(profile) {
      var matchedExperiences = this.experiences.filter(function (experience) {
        return isExperienceMatch({
          experience: experience,
          profile: profile
        });
      });
      return matchedExperiences.reduce(function (acc, experience) {
        var distribution = selectDistribution({
          experience: experience,
          profile: profile
        });
        return Object.assign({}, acc, _defineProperty({}, experience.id, distribution.index));
      }, {});
    }
  }, {
    key: "apiExperienceVariantIndexes",
    get: function get() {
      var profile = this.profile;
      if (!profile) {
        return {};
      }
      return this.calculateExperienceVariantIndexes(profile);
    }
  }, {
    key: "experienceVariantIndexes",
    get: function get() {
      var profile = this.profile;
      if (!profile) {
        return {};
      }
      return this.calculateExperienceVariantIndexes(Object.assign({}, profile, {
        audiences: this.activeAudiences
      }));
    }
  }]);
}(NinetailedPlugin);
if (typeof window === 'object' && !('process' in window)) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.process = {};
}
export { NinetailedPreviewPlugin, NinetailedPreviewPlugin as default };